import React from 'react';
import Headline from './Headline/Headline';
import HomePageAboutMe from './AboutMe/HomePageAboutMe';
import HomePageCallToAction from './CallToAction/HomePageCallToAction';
import LatestBlogPosts from './LatestBlogs/LatestBlogPosts';
import HomePagePhotography from './Photography/HomePagePhotography';
import FeaturedProjects from './FeaturedProjects/FeaturedProjects';

const HomePage = () => {
  return (
    <div 
      style ={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
    >
      <Headline />
      <div style={{ width: '100%' }}>
        <HomePageAboutMe /> 
      </div>
      <div style={{ width: '100%' }}>
        <HomePageCallToAction /> 
      </div>
      <div style={{ width: '100%' }}>
        <LatestBlogPosts />
      </div>
      <div style={{ width: '100%' }}>
        <HomePagePhotography />
      </div>
      <div style={{ width: '100%' }}>
        <FeaturedProjects />
      </div>
    </div>
  );
};

export default HomePage;